export enum logEventEnum {
    DEBUG = 'DEBUG', 
    INFO = 'INFO', 
    WARN = 'WARN', 
    ERROR = 'ERROR'
}